import React from "react";
import CO2EmissionEstimator from "./CO2EmissionEstimator";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import Scope3Layout from "../../../../Layout/Scope3Layout";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";
import GroupAdminSidebar from "../../../../Layout/GroupAdminSidebar";

const Emission = () => {
  const { user, module } = useUser();
  let hasAccess =
    user?.companyAdmin ||
    user?.facilityManger ||
    module?.includes("Environment | Scope 3");

  return (
    <MainDashboardLayout sidebar={user?.groupManager?<GroupAdminSidebar/>:<Scope3Layout />}>
      <Unauthorized requiredModule="Environment | Scope 3">
        <CO2EmissionEstimator />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Emission;
